/** @jsx jsx */
import { Title } from '@bottlebooks/gatsby-design-system';
import { Col } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';

export default function RelatedTitle({ children, ...rest }) {
  return (
    <Col flex sx={{ minWidth: ['100%', 'auto'] }} {...rest}>
      <Title variant="small">{children}</Title>
    </Col>
  );
}
